<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-ptwist shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container container-lg shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3  text-white">PlasticTwist Crowdsourcing
                </h1>
                <p class="lead text-white">Capturing the public perception of plastic</p>
                <base-button tag="a"
                             href="https://ptwist.csd.auth.gr"
                             target="_blank"
                             class="mb-3 mb-sm-0"
                             type="white"
                             :icon="{ prefix: 'fas', iconName: 'external-link-alt'}">
                  Learn more about PlasticTwist
                </base-button>
                <router-link to="/about">

                  <base-button tag="a"
                               href="https://ptwist.csd.auth.gr"
                               target="_blank"
                               class="mb-3 mb-sm-0"
                               type="white"
                               :icon="{ prefix: 'fas', iconName: 'info'}">
                    About
                  </base-button>
                </router-link>

                <h1 class="mt-5 mb-3 display-3  text-white">Crowdsourcing Open API</h1>
                <a href="https://ptwist.csd.auth.gr:20443/documentation" target="_blank" title="Docs">
                  <base-button class="mr-2 mb-3 mb-sm-0"
                               type="blue">
                    Browse api docs
                  </base-button>

                </a>
                <a href="https://ptwist.csd.auth.gr:20443/rss" target="_blank" title="Rss">
                  <router-link to="/rss">

                    <base-button class="mr-2 mb-3 mb-sm-0"
                                 type="orange">
                      RSS Feed
                    </base-button>
                  </router-link>

                </a>
              </div>
              <div class="col-lg-6 ">
                <img src="../assets/img/ptwist_logo_500_500.png"
                     class="w-50 mx-auto img-fluid d-none d-md-block landing-logo">
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container container-lg">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class=" col-lg-3">
                <card class="module-card border-0" shadow body-classes="py-5">
                  <icon :name="{ prefix: 'fas', iconName: 'map-marked-alt' }" type="warning" rounded
                        class="mb-4">
                  </icon>
                  <h6 class="text-warning text-uppercase">Locations</h6>
                  <p class="description mt-3">Geolocation and reverse geocoding, at city level, is used to display the
                    density of social media posts regarding plastics per geographic region.</p>
                  <!--<div>-->
                  <!--<badge type="warning" rounded>Twitter</badge>-->
                  <!--<badge type="warning" rounded>Facebook</badge>-->
                  <!--</div>-->
                  <router-link to="/visualizations/locations" title="Locations">
                    <base-button style="bottom: 20px;" tag="a" type="warning"
                                 class="mt-4 text-white text-white position-absolute">
                      Learn more
                    </base-button>
                  </router-link>
                </card>
              </div>
              <div class="col-lg-3 col-12">
                <card class="module-card border-0" shadow body-classes="py-5">
                  <icon :name="{ prefix: 'far', iconName: 'comments' }" type="primary" rounded
                        class="mb-4">
                  </icon>
                  <h6 class="text-primary text-uppercase">Wordclouds</h6>
                  <p class="description mt-3">Dynamically generated visual representations of the most frequently used
                    terms and hashtags regarding plastic thematics.</p>

                  <router-link to="/visualizations/wordclouds" title="Wordclouds">
                    <base-button style="bottom: 20px;" tag="a" type="primary" class="mt-4 text-white position-absolute">
                      Learn more
                    </base-button>
                  </router-link>
                </card>
              </div>
              <div class="col-lg-3">
                <card class="module-card border-0" shadow body-classes="py-5">
                  <icon :name="{ prefix: 'fas', iconName: 'stream' }" type="blue" rounded
                        class="mb-4">
                  </icon>
                  <h6 class="text-blue text-uppercase">Repositories</h6>
                  <p class="description mt-3">Data from various external interlinked repositories, giving access to
                    inspirational photographs and 3d designs about reused plastics.</p>
                  <router-link to="/repositories" title="Repositories">
                    <base-button style="bottom: 20px" tag="a" type="blue" class="mt-4 text-white position-absolute">
                      Learn more
                    </base-button>
                  </router-link>
                </card>
              </div>
              <div class="col-lg-3">
                <card class="module-card border-0" shadow body-classes="py-5">
                  <icon :name="{ prefix: 'fas', iconName: 'users' }" type="danger" rounded
                        class="mb-4">
                  </icon>
                  <h6 class="text-danger text-uppercase">Influential Content</h6>
                  <p class="description mt-3">Accounts, tweets and URLs that have the greatest impact on Twitter users
                    on the issues of plastic pollution, plastics recycling and reusing.
                  </p>
                  <router-link to="/prevalent-data/influencers" title="Influencers">
                    <base-button style="bottom: 20px" tag="a" type="danger" class="mt-4 text-white position-absolute">
                      Learn more
                    </base-button>
                  </router-link>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section bg-secondary">
      <div class="container ">
        <div class="row row-grid align-items-center">
          <div class="col-md-6">
            <div class="card bg-default shadow border-0">
              <img src="../assets/img/plastic_pollution.jpg" class=" img-fluid">
              <blockquote class="card-blockquote">
                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                     class="svg-bg">
                  <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                  <polygon points="0,42 583,95 683,0 0,95" opacity=".2"
                           class="fill-default"></polygon>
                </svg>
                <h4 class="display-3 font-weight-bold text-white">Plastic Pollution</h4>
                <p class="lead text-italic text-white">Plastic pollution is the accumulation of plastic
                  products in the environment that adversely affects wildlife, wildlife habitat and
                  humans. Plastics that act as pollutants are categorized into micro-, meso-, or macro
                  debris, based on size.</p>
              </blockquote>
            </div>
          </div>
          <div class="col-md-6">
            <div class="pl-md-5">
              <icon :name="{ prefix: 'fas', iconName: 'desktop' }" class="mb-5" size="lg" type="warning"
                    shadow rounded></icon>

              <h3>Presentation and visualization of social media data regarding plastic.</h3>
              <p class="lead">This tool allows users to understand plastics thematic relationships and impact their
                awareness and plastics reuse motivation, while at the same time inspires all stakeholders (citizens,
                fablabs and markets) around non-conventional and grass-rooted plastics reuse ideas and practices.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 bg-gradient-warning">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container py-0">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-lg-2 ml-lg-auto">
            <div class="position-relative pl-md-5">
              <img src="../assets/img/social_mining.png" class="img-center img-fluid">

            </div>
          </div>
          <div class="col-lg-6 order-lg-1">
            <div class="d-flex px-3">
              <div>
                <icon :name="{ prefix: 'fas', iconName: 'users-cog' }" size="lg"
                      class="bg-gradient-white"
                      color="primary" shadow
                      rounded></icon>
              </div>
              <div class="pl-4">
                <h4 class="display-3 text-white">Social Media Data Mining</h4>
                <p class="text-white">Using modern technologies to collect data from various sources, as
                  listed below</p>
              </div>
            </div>
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon :name="{ prefix: 'fab', iconName: 'twitter' }" gradient="twitter"
                        color="white" shadow rounded></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-primary">Twitter</h5>
                  <p>The <a target="_blank" href="https://developer.twitter.com/en/docs.html">Twitter
                    Official API</a> was used to gather both streaming data and user data
                    from Twitter.</p>
                </div>
              </div>
            </card>
            <!--<card shadow class="shadow-lg&#45;&#45;hover mt-5">-->
            <!--<div class="d-flex px-3">-->
            <!--<div>-->
            <!--<icon :name="{ prefix: 'fab', iconName: 'facebook-f' }" gradient="facebook"-->
            <!--color="white" shadow rounded></icon>-->
            <!--</div>-->
            <!--<div class="pl-4">-->
            <!--<h5 class="title text-primary">Facebook</h5>-->
            <!--<p>We gathered facebook pages data from several influencial pages using the <a-->
            <!--target="_blank" href="https://developers.facebook.com/">Official-->
            <!--Facebook API</a></p>-->
            <!--</div>-->
            <!--</div>-->
            <!--</card>-->
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <text-icon text="T" gradient="thingiverse"
                             color="white" shadow rounded></text-icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-primary">Thingiverse</h5>
                  <p>Using the <a target="_blank" href="https://www.thingiverse.com/developers">
                    Official Thingiverse API</a> we are able to show trending, popular or new
                    Thingiverse designs from both our pilots' creations or third-party creators.</p>
                </div>
              </div>
            </card>
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon :name="{ prefix: 'fab', iconName: 'flickr' }" gradient="flickr"
                        color="white" shadow rounded></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-primary">Flickr</h5>
                  <p>We utilize the search functionality of the <a target="_blank"
                                                                   href="https://www.flickr.com/services/api/">Flickr
                    Official API</a> to collect photographs based on various terms and hashtags.</p>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'home',
  components: {}
}
</script>
<style scoped>
  .module-card {
    height: 420px;
  }
</style>
